import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../lib/auth";
import { LogoMark } from "../components/Logo";
import { toast } from "sonner";
import { Mail, KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      toast.success("Se l'email è registrata riceverai un codice di reset");
      nav(`/reset-password?email=${encodeURIComponent(email)}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FFFAF5] flex items-center justify-center px-6 py-10 relative overflow-hidden">
      <div className="orb orb-orange" style={{width: 500, height: 500, top: -200, right: -100, opacity: 0.25}}/>
      <div className="relative w-full max-w-md card-smart p-8 md:p-10" data-testid="forgot-card">
        <Link to="/" className="inline-flex mb-6"><LogoMark size={64} pulse/></Link>
        <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#FF7A29] mb-3">
          <KeyRound className="w-4 h-4"/> Recupero password
        </div>
        <h1 className="font-display text-3xl mb-2">Password dimenticata?</h1>
        <p className="text-sm text-[#757575] mb-6">Nessun problema. Inserisci la tua email e riceverai un codice di 6 cifre per reimpostarla.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <div className="relative mt-1">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#757575]"/>
              <Input id="email" data-testid="forgot-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="rounded-xl pl-10 h-11" placeholder="tu@azienda.it"/>
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full rounded-full h-12 bg-[#FF7A29] hover:bg-[#E85D00] btn-glow shadow-md shadow-orange-200">
            {loading ? "Invio…" : "Invia codice di reset"}
          </Button>
        </form>
        <p className="text-sm text-[#555] mt-6 text-center"><Link to="/login" className="text-[#FF7A29] hover:underline">← Torna al login</Link></p>
      </div>
    </div>
  );
}
